import Heading from "~/components/lib/Heading";
import Text from "~/components/lib/Text";
import ManagedContent from "~/components/ManagedContent";
import Meta from "~/components/Meta";
import action from "~/routes/pages/blog/article/action";
import Comments from "~/routes/pages/blog/article/components/Comments";
import loader from "~/routes/pages/blog/article/loader";
import shouldRevalidate from "~/routes/pages/blog/article/shouldRevalidate";
import BlogContentWithSidebar from "~/routes/pages/blog/components/BlogContentWithSidebar";
import { formatDate } from "~/utils/date";
import type { Route } from "./+types";
import "./style.css";

export { action, loader, shouldRevalidate };

const SHIRTSPACE_TWITTER = "@shirtspacetees";
const SHIRTSPACE_FACEBOOK_ADMINS = "101298331924";
const DATE_FORMAT = "MMM dd, yyyy";

const BlogArticle = ({ loaderData }: Route.ComponentProps) => {
  const { article, comments, relatedProductPrices, canonicalUrl } = loaderData;
  const image = article.featuredImage;
  const description = article.summary ?? "";
  const publishedOn = formatDate(article.publishOn?.slice(0, 10), DATE_FORMAT);
  const updatedOn = formatDate(article.updatedAt?.slice(0, 10), DATE_FORMAT);
  return (
    <BlogContentWithSidebar
      relatedProducts={article.relatedProducts}
      relatedProductPrices={relatedProductPrices}
    >
      <Meta
        title={`${article.title} | ShirtSpace`}
        description={description}
        canonicalUrl={canonicalUrl}
        type="article"
        socialTitle={article.title}
        image={image?.originalUrl}
        twitterCard="summary"
      />
      {image && (
        <link
          rel="preload"
          href={image.largeUrl}
          as="image"
          fetchPriority="high"
        />
      )}
      <meta
        name="twitter:creator"
        content={article.twitterAuthor || SHIRTSPACE_TWITTER}
      />
      {article.publishOn && (
        <meta
          property="article:published_time"
          content={article.publishOn}
        />
      )}
      {article.updatedAt && (
        <meta
          property="article:modified_time"
          content={article.updatedAt}
        />
      )}
      <meta
        property="fb:admins"
        content={SHIRTSPACE_FACEBOOK_ADMINS}
      />
      {article.structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: article.structuredData }}
        />
      )}

      <article className="blog-article">
        {image && (
          <img
            className="blog-article__image"
            src={image.largeUrl}
            alt={image.altText ?? ""}
            fetchPriority="high"
          />
        )}
        <Heading
          element="h1"
          size="lg"
          className="blog-article__title"
        >
          {article.title}
        </Heading>
        <Text
          element="span"
          className="blog-article__byline"
        >
          By ShirtSpace
          {publishedOn && <> |&nbsp;{publishedOn}</>}
          {updatedOn && <>&nbsp;|&nbsp;Updated&nbsp;{updatedOn}</>}
        </Text>
        <ManagedContent
          html={article.body}
          className="blog-article__body"
        />
        <Comments comments={comments} />
      </article>
    </BlogContentWithSidebar>
  );
};

export default BlogArticle;
